<template>
	<aside class="webview-redraw-progress">
		<div class="webview-redraw-progress__inner">
			<p class="webview-redraw-progress__loading">
				<i class="webview-redraw-progress__loading--spoke" />
				<i class="webview-redraw-progress__loading--spoke" />
				<i class="webview-redraw-progress__loading--spoke" />
				<i class="webview-redraw-progress__loading--spoke" />
				<i class="webview-redraw-progress__loading--spoke" />
				<i class="webview-redraw-progress__loading--spoke" />
				<i class="webview-redraw-progress__loading--spoke" />
				<i class="webview-redraw-progress__loading--spoke" />
			</p>
		</div>
	</aside>
</template>

<script>

export default {
	name: 'WebviewRedrawProgress'
}
</script>

<style lang="scss">
// 変数定義SASS
@import "@/assets/sass/variable";

.webview-redraw-progress {
	position: absolute;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background: rgba($_black, .4);
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	opacity: 1;
	z-index: 9999;
	pointer-events: none;

	&__inner {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin: 0;
	}

	&__loading {
		// NNOTE: 定額デザインシステム外。このコンポーネントのローディング専用の変数
		$spoke-translate: 100%;
		$spoke-transform-origin: ($spoke-translate) * -.6;
		$spoke-size: 3px;

		position: relative;
		height: 30px;
		width: 30px;
		margin: 0;

		&--spoke {
			display: block;
			position: absolute;
			top: ($spoke-translate) * .7;
			left: calc(50% - #{$spoke-size} * 1.5);
			transform-origin: 50% $spoke-transform-origin;

			&:nth-of-type(0n+1) {
				transform: translateX($spoke-translate) rotate(-90deg);
				animation-delay: -0.875s;
			}
			&:nth-of-type(0n+2) {
				transform: translateX($spoke-translate) rotate(-45deg);
				animation-delay: -0.750s;
			}
			&:nth-of-type(0n+3) {
				transform: translateX($spoke-translate);
				animation-delay: -0.625s;
			}
			&:nth-of-type(0n+4) {
				transform: translateX($spoke-translate) rotate(45deg);
				animation-delay: -0.5s;
			}
			&:nth-of-type(0n+5) {
				transform: translateX($spoke-translate) rotate(90deg);
				animation-delay: -0.375s;
			}
			&:nth-of-type(0n+6) {
				transform: translateX($spoke-translate) rotate(135deg);
				animation-delay: -0.25s;
			}
			&:nth-of-type(0n+7) {
				transform: translateX($spoke-translate) rotate(180deg);
				animation-delay: -0.125s;
			}
			&:nth-of-type(0n+8) {
				transform: translateX($spoke-translate) rotate(225deg);
				animation-delay: 0;
			}

			&::after {
				content: '';
				display: block;
				background: $background-primary;
				width: $spoke-size;
				height: $spoke-size * 3;
				border-radius: $spoke-size;
				animation: spoke 1s infinite;
				animation-delay: inherit;
			}
		}
	}
}

// アニメーション
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes spoke {
  0% { opacity: 1; }
  100% { opacity: 0.2; }
}
</style>
